export default [["en-us", {
  "device_offline_error": "Your device seems to be offline, so sending messages won't work at the moment. We'll keep trying to reconnect, or you can retry.",
  "empty_list_header": "Welcome to Secure Messaging",
  "empty_list_text": "You don't have any conversations yet",
  "message_placeholder": "Send a message",
  "navigation": {
    "conversation_list": "Secure messages {amount, plural, =0 {} other {({amount})}}"
  },
  "new_line_hint": {
    "effect": "to add a new line",
    "keys": "Shift + Return"
  },
  "retry_connection": "Retry connection",
  "send": "Send",
  "truncated_system_message": {
    "footer": "Your Account Owner can request a Data Export at any time from their account, contact them for more information.",
    "text": "Your Messaging history with this client prior to {date} is available via the Practice Data Export. {footer}"
  },
  "unread_message_indicator": "Unread message indicator"
}]];